import React from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect, Route, Switch } from 'react-router-dom';

import Grid from '../../../../components/list/grid';
import DocumentService from '../../../../services/document.service';
import Navigation from '../../../../components/navigation';
import PageTitle from '../../../../components/pageTitle';
import StepFiles from '../install/stepFiles';
import Search from '../../../../components/searchField';
import Confirm from '../../../../components/confirm';
import DocPreviewModal from '../../../../components/modalWindows/documentPreviewModal';
import Loading3 from '../../../../components/Loading3';

const Documents = ({
  t,
  color,
  initCriteria,
  original,
  checked,
  updated,
  callback,
  showDelete,
  getColumns,
  moduleData,
  handleDrop,
  activeItem,
  upload_name,
  isErrorGrid,
  activeModal,
  toggleModal,
  showConfirm,
  onClickSave,
  hideConfirm,
  mulTempFiles,
  isSubmitting,
  callbackError,
  callbackToSetDoc,
  onRemoveCallback,
  changeStatusDocs,
  callbackToSetSearch,
  toggleModalPreview,
  toggleModalMass,
  activeModalMass,
  callbackMass,
  backgroundColor,
  enableCoverColor,
  backgroundCover,
  ...props
}) => (
  <React.Fragment>
    <PageTitle
      title={t('My documents')}
      backgroundPage={backgroundColor}
      backgroundCover={backgroundCover}
      enableCoverColor={enableCoverColor}
    />
    <section className="Blog2 boxs dpreview">
      <div className="container">
        <div className="Blog2inner boxs pdlr">
          <Navigation cssClass="leftKB" />
          <div className="middleKB">
            <div className="middleinner boxs">
              <Confirm
                show={showConfirm}
                cancelCallback={hideConfirm}
                successCallback={onRemoveCallback}
              />
              <div>
                <div className="docs-search-box"><Search callbackToSetSearch={callbackToSetSearch} placeholder={t('Search documents')} /></div>
                <div className="docs-upload-button"><Link to={'/docs'}><span>{t('All documents')}</span></Link></div>
                <div className="clear"></div>
              </div>
              <StepFiles
                t={t}
                upload_name={upload_name}
              />
              <div className="boxs surveybtn" style={{ position: 'inherit', marginTop: '5px' }}>
                <div className={`boxs ${color}`}>
                  <div className="left" />
                  <div className="right">
                    {mulTempFiles[upload_name] && Object.keys(mulTempFiles[upload_name]).length ?
                      <span>
                        <button
                          onClick={e => onClickSave(e)}
                          type="submit"
                          className={`tc next nextgray btnpurple save-btn ${isSubmitting ? 'save-btn_act' : ''}`}
                        >
                          {isSubmitting && <Loading3 />} {t('Save')}
                        </button>
                      </span>
                      : ''}
                  </div>
                  <div className="clear" />
                </div>
              </div>
              <div className="DocBox boxs">
                <div className="">
                  <div className="boxs docDTable_pres">
                    <div className="boxs docDTable document-manage">
                      <Grid
                        id="documents"
                        service={DocumentService}
                        columns={getColumns({ t, ...props })}
                        initCriteria={{ ...initCriteria, original }}
                        original={original}
                        saveFilter={false}
                        checked={checked}
                        showChecked={false}
                        updated={updated}
                        current={activeItem}
                        backgroundColor={backgroundColor}
                        callbackToSetUser={callbackToSetDoc}
                        callbackError={callbackError}
                        {...props}
                      />
                      <Switch>
                        <Route
                          path="/my-docs/:id"
                          exact
                          render={prop => (<DocPreviewModal
                            active
                            toggleModal={toggleModalPreview}
                            moduleData={moduleData}
                            {...prop}
                          />
                       )}
                        />
                        <Redirect to="/my-docs" />
                      </Switch>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </React.Fragment>
);

Documents.propTypes = {
  t: PropTypes.func.isRequired,
  onClickSave: PropTypes.func.isRequired,
  callbackToSetDoc: PropTypes.func.isRequired,
  toggleModalPreview: PropTypes.func.isRequired,
  toggleModalMass: PropTypes.func.isRequired,
  activeModalMass: PropTypes.bool.isRequired,
  callbackMass: PropTypes.func.isRequired,
  isErrorGrid: PropTypes.object.isRequired,

};

export default Documents;



// WEBPACK FOOTER //
// ./src/views/modules/documents/mydocs/Documents.jsx